import { businessLoginDTO } from "../../interfaces/businessInterface";
import { ResponseDTO } from "../../interfaces/response";
import { BusinessServices } from "../services/BusinessServices";

export class BusinessController {
    private  businessServices = new BusinessServices();

    public async businessLogin(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        return await this.businessServices.businessLogin(dataBody)
    }

    public async businessPasswordValidate(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        return await this.businessServices.businessPasswordValidate(dataBody)
    }

    public async businessPasswordRecovery(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        return await this.businessServices.businessPasswordRecovery(dataBody)
    }

    public async businessPasswordChange(dataBody: businessLoginDTO, accessToken: string): Promise<ResponseDTO | any> {
        return await this.businessServices.businessPasswordChange(dataBody, accessToken)
    }
}